<template>
  <v-dialog v-model="dialog" max-width="290px">
    <v-card
      class="py-2 strategio-card-container"
    >
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;"
      >{{title}}</v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        {{message}}
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="layout justify-center">
        <!-- <v-spacer></v-spacer> -->
        <v-btn
          small depressed rounded
          style="color:white;"
          class="strategio-dialog-button"
          color="grey lighten-0"
          @click.native="dialog = false"
        >Cerrar</v-btn>
        <v-btn
          small depressed rounded
          class="strategio-dialog-button"
          color="error"
          @click.native="accept()"
        >Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import eventBus from '../../utils/eventBus'
export default {
  name: 'are-you-sure-dialog',
  created () {
    eventBus.$off('open-are-you-sure-dialog')
    eventBus.$on('open-are-you-sure-dialog', (data) => {
      this.dialog = true
      this.title = data.title
      this.message = data.message
      this.onOk = data.onOk
    })
  },
  data () {
    return {
      dialog: false,
      title: '',
      message: '',
      onOk: () => {}
    }
  },
  methods: {
    accept () {
      this.onOk()
      this.dialog = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/are-you-sure-dialog.vue